export default __webpack_public_path__ + "static/media/a6.41a76773.png";